import { render } from "./TotalWorkers.vue?vue&type=template&id=55c2df7a&ts=true"
import script from "./TotalWorkers.vue?vue&type=script&lang=ts"
export * from "./TotalWorkers.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__